module.exports = __webpack_public_path__ + "static/media/default.09da4995.png";


//////////////////
// WEBPACK FOOTER
// ./src/carSteward/index/default.png
// module id = 1194
// module chunks = 0